import { createSlice } from '@reduxjs/toolkit';
import http from '../../common/cticApi';
// initial state
export const initialState = {
  requiredDocumentLoader: false,
  error: null,
  success: false,
  requiredDocument: [], 
};


// our slice
const requiredDocumentSlice = createSlice({
  name: 'requiredDocument',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.requiredDocumentLoader = true;
    },
    setError: (state, { payload }) => {
      state.requiredDocumentLoader = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.requiredDocumentLoader = false;
      state.error = false;
      state.success = true;
    },
    setRequiredDocumentDetails: (state, { payload }) => {
        state.requiredDocument = payload;
      
    },
  },
});

// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setRequiredDocumentDetails,
} = requiredDocumentSlice.actions;

export const requiredDocumentSelector = (state) => state.requiredDocument;

export const GetAllRequiredDocument = (FileID,userId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
        fileID:FileID,
        UserID: userId,
        language:'en'
      };
    let data = { UserID: userId, RequestObject: request };
    

    const results = await http
      .post('Order/GetSavedMissingInfoForFile', request)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setRequiredDocumentDetails(results.data.responseObject?.missingList));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

// export the default reducer
export default requiredDocumentSlice.reducer;
